import React from 'react';
import { ReactComponent as SerbiaIcon } from '../../assets/serbia.svg';
import { ReactComponent as KingdomIcon } from '../../assets/kingdom.svg';
import './langButton.scss';
import { useLanguage } from '../../context/LanguageContext';

const LangButton = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <label className="lang-button">
      <input
        type="checkbox"
        className="checkbox"
        checked={language === 'sr'}
        onChange={toggleLanguage}
      />
      <div className="back"></div>
      <KingdomIcon />
      <SerbiaIcon />
    </label>
  );
};

export default LangButton;
